import ashfall from './ashfall';
import craterPlume from './craterPlume';
import dustDevil from './dustDevil';
import fairyLights from './fairyLights';
import geyserSteam from './geyserSteam';
import labyrinthGlow from './labyrinthGlow';
import livingLava from './livingLava';
import rippleRings from './rippleRings';
import sandStreamers from './sandStreamers';
import snowDrift from './snowDrift';
import sporePuffs from './sporePuffs';
import sunStars from './sunStars';
import vultureKettle from './vultureKettle';
import willOWisps from './willOWisps';
import windGust from './windGust';
import windVeils from './windVeils';

/**
 * Построители эффектов подложек: вид эффекта -> его построитель (см.
 * scenes/FieldBiomeEffects и configs/biomeEffects).
 *
 * Построитель: {kind, textures, createTracks(context, params) -> дорожки,
 * usesWind?}. context — что эффект знает о поле (см. biomeContext), params —
 * числа эффекта для подложки из configs/biomeEffects. usesWind: false — эффекту
 * ветер матча не нужен: при смене ветра его дорожки не трогаются.
 */
const BUILDERS = [
  windGust,
  sandStreamers,
  snowDrift,
  dustDevil,
  vultureKettle,
  windVeils,
  labyrinthGlow,
  rippleRings,
  geyserSteam,
  craterPlume,
  livingLava,
  ashfall,
  sunStars,
  willOWisps,
  sporePuffs,
  fairyLights,
];

export const BIOME_EFFECT_BUILDERS = Object.freeze(
  Object.fromEntries(BUILDERS.map((builder) => [builder.kind, builder]))
);
